/* eslint-disable no-console */
/* eslint-disable prefer-template */
/* eslint-disable no-debugger */
/* 企业微信扫码登录页面 */
import React, { useEffect, useState } from 'react';
import { connect, useHistory } from 'umi';
import type { Dispatch } from 'umi';
import { useLocation } from 'umi';
import type { StateType } from '@/models/login';
import type { ConnectState } from '@/models/connect';
import { getUser, getCredentials, changePassword } from './service';
// import './wwLogin';
import styles from './index.less';
import { CopyrightOutlined } from '@ant-design/icons';
import { Input, Button, Space, Modal, message } from 'antd';
import { create, set } from 'lodash';

export type LoginProps = {
  dispatch: Dispatch;
  userLogin: StateType;
  submitting?: boolean;
};

type windowSuper = Window &
  typeof globalThis & {
    WwLogin: (arg: any) => void;
  };

const Login: React.FC<LoginProps> = (props) => {
  const { dispatch } = props;
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [changePasswordModalVisible, setChangePasswordModalVisible] =
    useState<boolean>(false);
  const [changePasswordForm, setChangePasswordForm] = useState({
    username: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [changePasswordLoading, setChangePasswordLoading] =
    useState<boolean>(false);
  // const { userLogin = {} } = props;
  // const { status, type: loginType } = userLogin;
  // const [type, setType] = useState<string>('account');
  const location = useLocation();
  const history = useHistory();

  // useEffect(() => {
  //   if (
  //     location.search.includes('code=') &&
  //     location.search.includes('state=InSnail')
  //   ) {
  //     // const code = /(?<=code=).*?(?=&state)/.exec(location.search)?.[0]; // Safari不支持断言匹配的正则表达式，使用分组匹配来兼容
  //     const code = /code=.*?&state/
  //       .exec(location.search)?.[0]
  //       .replace('code=', '')
  //       .replace('&state', '');
  //     createUserLogin({ code });
  //   }
  //   initLogin();
  // }, [location.search]);

  const initLogin = async () => {
    const init = await getCredentials();
    console.log('init', init);
    if (!init) return;
    // (window as windowSuper).WwLogin({
    //   id: 'qrcode',
    //   appid: init.CORP_ID,
    //   agentid: init.AGENT_ID,
    //   redirect_uri: init.REDIRECT_URI,
    //   state: init.STATE,
    //   href: '',
    // });
  };

  const createUserLogin = async () => {
    try {
      const response = await getUser({ username, password });
      if (!response.data?.token) {
        message.error(response.message || '用户名或密码错误，请重试！');
        return;
      }
      localStorage.setItem('token', response.data.token ?? '');
      window.location.href = '/';
    } catch (error) {
      message.error('登录失败，请重试！');
    }
  };

  const handleChangePassword = async () => {
    if (
      !changePasswordForm.username ||
      !changePasswordForm.oldPassword ||
      !changePasswordForm.newPassword
    ) {
      message.error('请填写完整信息');
      return;
    }

    if (changePasswordForm.newPassword !== changePasswordForm.confirmPassword) {
      message.error('新密码与确认密码不匹配');
      return;
    }

    if (changePasswordForm.newPassword.length < 6) {
      message.error('新密码长度不能少于6位');
      return;
    }

    setChangePasswordLoading(true);
    try {
      const response = await changePassword({
        username: changePasswordForm.username,
        oldPassword: changePasswordForm.oldPassword,
        newPassword: changePasswordForm.newPassword,
      });

      if (response.code === 0) {
        message.success('密码修改成功');
        setChangePasswordModalVisible(false);
        setChangePasswordForm({
          username: '',
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
        });
      } else {
        message.error(response.message || '密码修改失败');
      }
    } catch (error) {
      message.error('密码修改失败，请重试');
    } finally {
      setChangePasswordLoading(false);
    }
  };

  const handleCloseChangePasswordModal = () => {
    setChangePasswordModalVisible(false);
    setChangePasswordForm({
      username: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <img
          alt="logo"
          className={styles.logo}
          src={require('@/assets/logo.svg')}
        />
        <span className={styles.title}>BB8</span>
      </div>
      <div className={styles.desc}>请输入用户名和密码</div>
      <Space
        direction="vertical"
        align="center"
        size="large"
        className={styles.main}
      >
        <Input
          id="username"
          placeholder="用户名"
          style={{ width: '300px' }}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input.Password
          id="password"
          placeholder="密码"
          style={{ width: '300px' }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onPressEnter={createUserLogin}
        />
        <Button
          id="login"
          type="primary"
          style={{ width: '300px' }}
          onClick={createUserLogin}
        >
          登录
        </Button>
        <Button type="link" onClick={() => setChangePasswordModalVisible(true)}>
          修改密码
        </Button>
      </Space>

      <Modal
        title="修改密码"
        open={changePasswordModalVisible}
        onOk={handleChangePassword}
        onCancel={handleCloseChangePasswordModal}
        confirmLoading={changePasswordLoading}
        width={400}
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Input
            placeholder="用户名"
            value={changePasswordForm.username}
            onChange={(e) =>
              setChangePasswordForm({
                ...changePasswordForm,
                username: e.target.value,
              })
            }
          />
          <Input.Password
            placeholder="原密码"
            value={changePasswordForm.oldPassword}
            onChange={(e) =>
              setChangePasswordForm({
                ...changePasswordForm,
                oldPassword: e.target.value,
              })
            }
          />
          <Input.Password
            placeholder="新密码（至少6位）"
            value={changePasswordForm.newPassword}
            onChange={(e) =>
              setChangePasswordForm({
                ...changePasswordForm,
                newPassword: e.target.value,
              })
            }
          />
          <Input.Password
            placeholder="确认新密码"
            value={changePasswordForm.confirmPassword}
            onChange={(e) =>
              setChangePasswordForm({
                ...changePasswordForm,
                confirmPassword: e.target.value,
              })
            }
          />
        </Space>
      </Modal>

      <footer className={styles.footer}>
        <CopyrightOutlined />
        <span>骈梦科技</span>
      </footer>
    </div>
  );
};

export default connect(({ login, loading, user }: ConnectState) => ({
  userLogin: login,
  submitting: loading.effects['login/login'],
  user,
}))(Login);
